import React from 'react';
import { DataInputStep } from './DataInputStep';
import { TableInputStep } from './TableInputStep';
import { Separator } from '@/components/ui/separator';
export function CombinedInputStep({
  formData,
  setFormData
}) {
  return <div className="space-y-10" data-id="element-115">
      <div className="rounded-lg p-6" data-id="element-116">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-117">
          Step 1: Select Your Units
        </h3>
        <DataInputStep formData={formData} setFormData={setFormData} data-id="element-118" />
      </div>
      <Separator className="my-8" data-id="element-119" />
      <div className="rounded-lg p-6" data-id="element-120">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-121">
          Step 2: Enter Your Cargo Data
        </h3>
        <TableInputStep formData={formData} setFormData={setFormData} data-id="element-122" />
      </div>
    </div>;
}